import type { FC } from "react";
import type { IconProps } from "./types";

/**
 * Wrap a game-icons.net glyph as a furniture icon.
 *
 * The originals are 512×512 solid silhouettes. They are scaled into the cell with a little
 * padding, and coloured by the theme's palette: pieces you can stand on are drawn in the light
 * stroke colour, blocking pieces in the solid fill — the same convention the classic set uses,
 * so "can I stand here?" reads the same in every theme.
 */
export function gameIcon(pathData: string, options: { accent?: boolean } = {}): FC<IconProps> {
  return function GameIcon({ x, y, size, occupiable, palette }: IconProps) {
    const pad = size * 0.16;
    const scale = (size - pad * 2) / 512;
    const colour = options.accent ? palette.accent : occupiable ? palette.stroke : palette.fill;

    return (
      <g transform={`translate(${x + pad} ${y + pad}) scale(${scale})`}>
        <path
          d={pathData}
          fill={colour}
          {...(occupiable || options.accent
            ? {}
            : { stroke: palette.strokeBlocking, strokeWidth: 10 })}
        />
      </g>
    );
  };
}
